import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getCompany, getSubcompany } from 'auth/selectors';
import * as List from 'selectors/lists';
import { getIsLoadingForm } from 'selectors/assets';
import { getAssetsDisableFormConfig } from 'containers/assets/actions';

class AssetDisableFormConfig extends PureComponent {
  static propTypes = {
    catalogs: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    inpcs: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    render: PropTypes.func.isRequired,
    subcompany: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.props.getConfig(this.props.company.id, this.props.subcompany.id);
  }

  render = () =>
    this.props.render({
      catalogs: this.props.catalogs,
      inpcs: this.props.inpcs,
      isLoading: this.props.isLoading,
    });
}

const mapStateToProps = (state) => {
  return {
    catalogs: List.getCatalogsAndVisibleElements(state),
    company: getCompany(state),
    isLoading: getIsLoadingForm(state),
    subcompany: getSubcompany(state),
    inpcs: List.getInpcs(state),
  };
};

const mapDispatchToProps = { getConfig: getAssetsDisableFormConfig };

export default connect(mapStateToProps, mapDispatchToProps)(AssetDisableFormConfig);



// WEBPACK FOOTER //
// src/containers/assets/AssetsDisableFormConfig.js